import { createPersistentFlag } from './persistentFlag.ts';

// #400 — whether the left tool rail is collapsed to its icon strip.
// #401 follow-up — whether the right FILTER/EDIT/COMPOSE panel is collapsed to its tab strip.
// Both record the user's intent; the shell also gates on viewport width (each is an off-canvas
// drawer at <= 960px).
export const useRailCollapsed = createPersistentFlag('peruselab.workspace.railCollapsed');
export const useRightPanelCollapsed = createPersistentFlag('peruselab.workspace.rightPanelCollapsed');
